import PropTypes from 'prop-types'
import React from 'react'
import Helmet from 'react-helmet'

import meta from 'constants/meta'

export default function Meta({ children, title, ...others }: props) {
  return (
    <Helmet {...others} titleTemplate={`%s | ${meta.TITLE}`}>
      {title &&
        <title>
          {title}
        </title>
      }
      {children}
    </Helmet>
  )
}

Meta.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/Meta/Meta.js